import { signInWithGoogle, signInWithLinkedIn } from '@/app/auth/actions'
import { Button } from "@/components/ui/button"
import { FaGoogle, FaLinkedin } from "react-icons/fa";
export function ProviderSigninBlock() {
    return (
        <>
            <div data-testid="provider-signin-block" className="flex flex-row gap-2">
                <form data-testid="signin-with-linkedin" action={signInWithLinkedIn} className="basis-full">
                    <Button variant="outline" aria-label="Sign in with LinkedIn" className="w-full">
                        <FaLinkedin />
                    </Button>
                </form>
                <form data-testid="signin-with-google" action={signInWithGoogle} className="basis-full">
                    <Button variant="outline" aria-label="Sign in with Google" type="submit" className="w-full">
                        <FaGoogle />
                    </Button>
                </form>
            </div>
        </>
    )
}